import React, { Component } from "react";
import PropTypes from "prop-types";
import { TextArea, Form } from "semantic-ui-react";

/**
 * Import Simple text editor styles
 */
import "./SimpleTextEditor.css";

/**
 * SimpleTextEditor : Component
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Editor for simple text documents
 */
class SimpleTextEditor extends Component {
  constructor(props) {
    super(props);
    this.state = this.translateFileContentIntoState();
  }

  state = {};

  /**
   * componentDidUpdate: ()
   * Updates file content if current document changes.
   */
  componentDidUpdate() {
    if (this.props.file.id !== this.state.currentFileIdentifier) {
      this.setState(this.translateFileContentIntoState());
    }
  }

  /**
   * onChangeText = _, sender => ()
   * Updates the document with any changes to the text.
   */
  onChangeText = (_, { value }) => {
    const { file, isReadOnlyMode } = this.props;
    const reference = this;

    if (isReadOnlyMode) {
      return;
    }

    this.setState(
      {
        currentFileContent: value
      },
      () => {
        const document = file;

        if (!document.content) document.content = {};
        document.content.text = reference.state.currentFileContent;

        this.props.updateDocument(document);
      }
    );
  };

  /**
   * translateFileContentIntoState = () => Object
   * Returns a new state object based on the current file.
   */
  translateFileContentIntoState = () => ({
    currentFileContent: this.readFileContent(),
    currentFileIdentifier: this.props.file.id
  });

  /**
   * readFileContent = () => String
   * Reads the contents of the current file and returns a String
   * of its text.
   */
  readFileContent = () => {
    if (
      this.props.file &&
      this.props.file.content &&
      this.props.file.content.text
    ) {
      return this.props.file.content.text;
    }
    return "";
  };

  /**
   * render()
   * Renders the simple editor component.
   */
  render() {
    return (
      <div className="ed-editor-view ed-editor-simple-text">
        <Form>
          <TextArea
            value={this.state.currentFileContent}
            onChange={this.onChangeText}
            disabled={this.props.isReadOnlyMode}
          />
        </Form>
      </div>
    );
  }
}

SimpleTextEditor.propTypes = {
  /**
   * Currently open file in editor
   */
  file: PropTypes.shape({
    content: PropTypes.shape({
      text: PropTypes.string
    }),
    id: PropTypes.string
  }),
  /**
   * Function to update and save document
   */
  updateDocument: PropTypes.func.isRequired,
  /**
   * True if the editor should not permit any changes
   */
  isReadOnlyMode: PropTypes.bool
};

SimpleTextEditor.defaultProps = {
  file: {
    context: {
      text: ""
    },
    id: ""
  },
  isReadOnlyMode: false
};

export default SimpleTextEditor;



// WEBPACK FOOTER //
// ./src/modules/editor/simpletext/SimpleTextEditor.js